import { useMutation, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { DisplayColumnSettings } from '@/models/features/display-column.models'

import { getDisplayColumnQueryKey } from './get-display-column'

export type UpdateDisplayColumnRequest = Omit<DisplayColumnSettings, 'fieldType'>

const updateDisplayColumn = async (data: UpdateDisplayColumnRequest) => {
  const response = await authAPI.put<DisplayColumnSettings>('/display-column', data)
  return response.data
}

export const useUpdateDisplayColumn = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateDisplayColumn,
    onSuccess: (settings, { buildingId, column, dashboard }) => {
      queryClient.setQueryData(
        getDisplayColumnQueryKey({ buildingId, column, dashboard }),
        settings,
      )
    },
  })
}
